__turbopack_context__.v({
  "btn": "ScrollToButton-module-scss-module__M7g94W__btn",
  "icon": "ScrollToButton-module-scss-module__M7g94W__icon",
});
